function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#d6242d;}.cls-2{fill:#fff;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "AWS-Key-Management-Service_light-bg");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Reference"
}, React.createElement("rect", {
  id: "Red_Light_BG",
  "data-name": "Red Light BG",
  className: "cls-1",
  width: 75,
  height: 75
}), React.createElement("g", {
  id: "Product_Icon",
  "data-name": "Product Icon"
}, React.createElement("path", {
  className: "cls-2",
  d: "M24.5,62a1,1,0,0,1-.75-.34l-3.5-4A1,1,0,0,1,20,57V54.42l-2.71-2.71a1,1,0,0,1,0-1.42L20,47.59V46.42l-2.71-2.71a1,1,0,0,1,0-1.42L20,39.59V37.17a12.45,12.45,0,0,1-8-11.82,12.5,12.5,0,0,1,25,.15,12.43,12.43,0,0,1-8,11.66V58a1,1,0,0,1-.35.76l-3.5,3A1,1,0,0,1,24.5,62ZM22,56.62l2.6,3L27,57.54V36.45a1,1,0,0,1,.7-1,10.49,10.49,0,1,0-6.43,0,1,1,0,0,1,.73,1V40a1,1,0,0,1-.29.71L19.42,43l2.29,2.29A1,1,0,0,1,22,46v2a1,1,0,0,1-.29.7L19.42,51l2.29,2.29A1,1,0,0,1,22,54ZM24.5,26.5A4.5,4.5,0,1,1,29,22,4.51,4.51,0,0,1,24.5,26.5Zm0-7A2.5,2.5,0,1,0,27,22,2.5,2.5,0,0,0,24.5,19.5Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M61.09,55H31V53H61V31H39V29H61.09A1.9,1.9,0,0,1,63,30.87V53.13A1.9,1.9,0,0,1,61.09,55Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M34.5,45.5a4,4,0,1,1,4-4A4,4,0,0,1,34.5,45.5Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,34.5,39.5Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M44.5,45.5a4,4,0,1,1,4-4A4,4,0,0,1,44.5,45.5Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,44.5,39.5Z"
}), React.createElement("rect", {
  className: "cls-2",
  x: 31,
  y: 48,
  width: 7,
  height: 2
}), React.createElement("rect", {
  className: "cls-2",
  x: 41,
  y: 48,
  width: 7,
  height: 2
}), React.createElement("rect", {
  className: "cls-2",
  x: 51,
  y: 48,
  width: 7,
  height: 2
})));

var SvgAwsKms = function SvgAwsKms(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 75 75",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsKms, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-KMS.ab470389.svg";
export { ForwardRef as ReactComponent };